import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {siteSchema} from '../utils/schemas/site';

import {siteKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getSite = async (id: string) => {
  const data = await api.get(`sites/${id}`).json();
  return siteSchema.parse(data);
};

export const useSite = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: siteKeys.detail(id),
    queryFn: () => getSite(id),
  });
};
export const useSiteLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getSite;
